import { render, staticRenderFns } from "./CommonPage.vue?vue&type=template&id=33d0a67e"
import script from "./CommonPage.vue?vue&type=script&lang=js"
export * from "./CommonPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d0a67e')) {
      api.createRecord('33d0a67e', component.options)
    } else {
      api.reload('33d0a67e', component.options)
    }
    module.hot.accept("./CommonPage.vue?vue&type=template&id=33d0a67e", function () {
      api.rerender('33d0a67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/return/components/CommonPage.vue"
export default component.exports